import { AppraiserLicenseType } from './AppraiserLicenseType';

export const AppraiserLicenseTypeOptions = [
    {
        id: AppraiserLicenseType.Licensed,
        name: 'Licensed',
    },
    {
        id: AppraiserLicenseType.Residential,
        name: 'Residential',
    },
    {
        id: AppraiserLicenseType.General,
        name: 'General',
    },
];
